import React from "react";
import { getNamedRoutes } from "app/routeRegistry";

/**
 * Accessible à /route-registry
 * Retourne un JSON de toutes les routes front ayant un id et un name.
 */
const RouteRegistryJson = () => {
  const routes = getNamedRoutes();

  return (
    <pre style={{ fontFamily: "monospace", padding: 24 }}>
      {JSON.stringify(routes, null, 2)}
    </pre>
  );
};

export default RouteRegistryJson;
